import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, queryString } from "../api.js";
import { ErrorBox, Pager, VerdictPill, fmtRelative, shortHwid } from "../components/helpers.jsx";

const LIMIT = 50;

export default function Attempts() {
    const [data, setData]     = useState({ rows: [], total: 0 });
    const [q, setQ]           = useState("");
    const [verdict, setVerdict] = useState("");
    const [endpoint, setEp]   = useState("");
    const [offset, setOffset] = useState(0);
    const [err, setErr]       = useState(null);

    useEffect(() => {
        let alive = true;
        api.get("/api/admin/attempts" + queryString({ q, verdict, endpoint, limit: LIMIT, offset }))
            .then((d) => { if (alive) setData(d); })
            .catch((e) => { if (alive) setErr(e.message); });
        return () => { alive = false; };
    }, [q, verdict, endpoint, offset]);

    return (
        <>
            <div className="page-header">
                <div>
                    <h1>Attempts</h1>
                    <div className="sub">Every processed load — click a row for the full telemetry snapshot.</div>
                </div>
            </div>

            <ErrorBox>{err}</ErrorBox>

            <div className="table-wrap">
                <div className="table-toolbar">
                    <input placeholder="Search subject / hwid / ip…"
                           value={q} onChange={(e) => { setOffset(0); setQ(e.target.value); }} />
                    <select value={verdict} onChange={(e) => { setOffset(0); setVerdict(e.target.value); }}>
                        <option value="">all verdicts</option>
                        <option value="allow">allow</option>
                        <option value="deny">deny</option>
                        <option value="ban">ban</option>
                    </select>
                    <select value={endpoint} onChange={(e) => { setOffset(0); setEp(e.target.value); }}>
                        <option value="">all endpoints</option>
                        <option value="product">product</option>
                        <option value="recheck">recheck</option>
                    </select>
                </div>
                <table className="data">
                    <thead>
                        <tr>
                            <th>When</th>
                            <th>Subject</th>
                            <th>HWID</th>
                            <th>Verdict</th>
                            <th>Category</th>
                            <th>Reason</th>
                            <th>IP</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.rows.length === 0 && (
                            <tr><td colSpan={7} className="text-dim" style={{ padding: 24, textAlign: "center" }}>
                                No attempts yet
                            </td></tr>
                        )}
                        {data.rows.map((r) => (
                            <tr key={r.id}>
                                <td title={new Date(r.createdAt).toLocaleString()}>
                                    <Link to={`/attempts/${r.id}`}>{fmtRelative(r.createdAt)}</Link>
                                </td>
                                <td>
                                    {r.subjectLabel && (
                                        <div style={{ fontWeight: 500 }}>{r.subjectLabel}</div>
                                    )}
                                    <div className="mono text-dim" style={{ fontSize: 11 }}>{r.subject}</div>
                                </td>
                                <td className="mono" title={r.hwid ?? ""}>{shortHwid(r.hwid)}</td>
                                <td><VerdictPill verdict={r.verdict} /></td>
                                <td>{r.category ?? <span className="text-dim">—</span>}</td>
                                <td className="text-dim" style={{ maxWidth: 400, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} title={r.reason ?? ""}>
                                    {r.reason ?? "—"}
                                </td>
                                <td className="mono text-dim">{r.ip ?? "—"}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                <Pager total={data.total} limit={LIMIT} offset={offset} onChange={setOffset} />
            </div>
        </>
    );
}
